import { Component, OnInit } from "@angular/core";
import { PostsService } from "./posts.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: "posts-component",
  template: require('./posts.component.html'),
  styles: [require('./posts.component.scss')]
})
export class PostsComponent implements OnInit {
  posts: any[];
  errorMessage: any;
  predicate: string = "created_at";
  reverse: boolean;
  onlyActive: boolean = true;
  projects: any[] = [{ name: "Projects" }];
  nationalities: any[] = [{ name: "Nationalities" }];
  employers: any[] = [{ name: "Employers" }];
  countries: any[] = [{ name: "Countries" }];
  projectFilter: string;
  nationalityFilter: string;
  employerFilter: string;
  countryFilter: string;
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;

  constructor(private service: PostsService, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.getCountries();
    this.getNationalities();
    this.getPosts().subscribe((res) => {
      this.getProjects();
      this.getEmployers();
      this.sortBy("it.created_at", "created_at");
    });
    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    this.itemsPerPage = this.service.getItemsPerPage();
  }

  getPosts() {
    return this.service.getPosts().map(
      (posts) => {
        this.posts = posts;
      },
      (error) => (this.errorMessage = error)
    );
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = this.projects.concat(projects);
    });
  }

  getNationalities() {
    let nations = this.service.getNationalities();
    this.nationalities = this.nationalities.concat(nations);
  }

  getCountries() {
    let nations = this.service.getNationalities();
    this.countries = this.countries.concat(nations);
  }

  getEmployers() {
    this.service.getEmployers().subscribe((employers) => {
      this.employers = this.employers.concat(employers);
    });
  }

  getCountryNames(ids: string[]): string[] {
    return this.service.getCountryNames(ids);
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function(
      "it",
      `return (${getField} || '').toLowerCase();`
    );
  }

  editPost(post: any) {
    PostsService.currentPost = post;
    this.router.navigate(["/editpost"]);
  }

  onChangeItemsPerPage(value) {
    this.service.saveItemsPerPage(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/posts/posts.component.ts